import React, { Component } from 'react';
import Slider from 'react-slick';
import _ from 'lodash';
import BrowserUtils from '../../../utils/BrowserUtils';
import FinancialStoriesStore from '../../../stores/FinancialStoriesStore';
import LoaderComponent from '../../common/LoaderComponent';
import 'picturefill';

class SlickCarousel extends Component {
  constructor(props) {
    super(props);
    this.onTileClick = this.onTileClick.bind(this);
  }

  shouldComponentUpdate() {
    // returns boolean value.
    // returns true by default.
    // if there is no needed to re-render even after the state or props updated, then return false
    return true;
  }

  onTileClick(e, id) {
    e.preventDefault();
    this.props.onTileClick(id);
  }

  getSlides() {
    const tiles = [];
    const isBusinessPromo = this.props.isBusinessPromo;
    _.map(this.props.slides, (slide, index) => {
      if (
        !FinancialStoriesStore.getTileLoader(slide.id) &&
        this.props.slides.length > 1 &&
        slide.id !== 'projections' &&
        !isBusinessPromo
      ) {
        tiles.push(
          <div
            key={`SlickCarousel_${slide.id}_LoaderComponent_${index}`}
            className="c-slider__item"
          >
            <LoaderComponent type="small" />
          </div>
        );
      } else {
        tiles.push(
          <div
            key={`SlickCarousel_${slide.id}_${index}`}
            className={`c-slider__item c-slider__item--${slide.id} ${
              isBusinessPromo ? 'c-slider__item--bp' : ''
            }`}
            aria-label={`${index + 1} of ${this.props.slides.length}`}
          >
            <a
              href="javascript:void(0)"
              className="c-slider__container"
              onClick={(e) => {
                this.onTileClick(e, slide.id);
              }}
            >
              <img
                className="c-slider__image pull-right"
                src={slide.image}
                alt=""
              />
              <p>
                {isBusinessPromo ? (
                  <div className="c-slider__container--bptext">
                    {slide.title}
                  </div>
                ) : (
                  ''
                )}
                {slide.text}{' '}
                <span
                  className={`${
                    isBusinessPromo
                      ? 'c-slider__container--bptext'
                      : 'c-slider__container--btext'
                  }`}
                >
                  {slide.btnLabel}
                </span>
              </p>
            </a>
          </div>
        );
      }
    });
    return tiles;
  }

  render() {
    let centerMode = true;
    let variableWidth = true;
    if (this.props.slides.length > 1 || BrowserUtils.isTabletView()) {
      centerMode = false;
      variableWidth = false;
    }
    let settings = {
      dots: false,
      infinite: false,
      slidesToShow: 3,
      speed: 500,
      slidesToScroll: 1,
      draggable: true,
      centerMode,
      arrows: true,
      className: 'c-slider',
      variableWidth,
      responsive: [
        { breakpoint: 720, settings: { slidesToShow: 1 } },
        { breakpoint: 1110, settings: { slidesToShow: 1.5 } },
        { breakpoint: 1400, settings: { slidesToShow: 2 } },
        { breakpoint: 2049, settings: { slidesToShow: 2.5 } },
      ],
    };
    return this.props.slides?.length ? (
      <div>
        <div>
          <section className="c-slider__section">
            <Slider {...settings}>{this.getSlides()}</Slider>
          </section>
        </div>
      </div>
    ) : null;
  }
}

export default SlickCarousel;
